import React from "react";

const ctx = {
  user: { name: "", phone: "" },
  isLogin: false,
  loadedAuth: false,
  showAuthDialog: false,
  globalMsg: "",
};

const AppContext = React.createContext(ctx);

export default AppContext;
